import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ContactProvider } from './context/ContactContext';
import HomePage from './pages/HomePage';
import AdminDashboard from './pages/AdminDashboard';
import AdminTeam from './pages/AdminTeam';
import AdminContact from './pages/AdminContact';
import AdminPortfolio from './pages/AdminPortfolio';
import AdminLogin from './pages/AdminLogin';
import ProtectedRoute from './components/ProtectedRoute';
import AdminLayout from './components/AdminLayout';

function App() {
  return (
    <AuthProvider>
      <ContactProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<AdminDashboard />} />
              <Route path="teams" element={<AdminTeam />} />
              <Route path="contact" element={<AdminContact />} />
              <Route path="portfolio" element={<AdminPortfolio />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
      </ContactProvider>
    </AuthProvider>
  );
}

export default App;